<template>
  <div>
    <div v-if="statistics" class="vx-row">
      <div class="vx-col w-full lg:w-1/3">
        <statistics-card-line
                hideChart
                class="mb-base"
                icon="UserIcon"
                icon-right
                :statistic="statistics.students.approved"
                statisticTitle="الطلبة" />
        <statistics-card-line
                hideChart
                class="mb-base"
                color="warning"
                icon="UserPlusIcon"
                icon-right
                :statistic="statistics.students.pending"
                statisticTitle="طلبات إنظمام الطلبة" />
        <statistics-card-line
                hideChart
                class="mb-base"
                color="danger"
                icon="UserXIcon"
                icon-right
                :statistic="statistics.students.suspended"
                statisticTitle="الطلبة الموقوفون" />
      </div>
      <div class="vx-col w-full lg:w-1/3">
        <statistics-card-line
                hideChart
                class="mb-base"
                icon="UserIcon"
                icon-right
                :statistic="statistics.teachers.approved"
                statisticTitle="أعضاء هيئة التدريس" />
        <statistics-card-line
                hideChart
                class="mb-base"
                color="warning"
                icon="UserPlusIcon"
                icon-right
                :statistic="statistics.teachers.pending"
                statisticTitle="طلبات إنظمام أعضاء هيئة التدريس" />
        <statistics-card-line
                hideChart
                class="mb-base"
                color="danger"
                icon="UserXIcon"
                icon-right
                :statistic="statistics.teachers.suspended"
                statisticTitle="أعضاء هيئة التدريس الموقوفين" />
      </div>
      <div class="vx-col w-full lg:w-1/3">
        <div class="w-full mb-base">
          <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="BookIcon"
                  icon-right
                  :statistic="statistics.courses"
                  statisticTitle="المواد الدراسية" />
        </div>
        <div class="w-full mb-base">
          <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="BookmarkIcon"
                  icon-right
                  :statistic="statistics.terms"
                  statisticTitle="الفصول الدراسية" />
        </div>
      </div>
    </div>
    <vx-card v-if="termStatistics && coursesStatistics" :title="`احصائية المواد الدراسية للفصل الحالي ${termStatistics.name}`">

      <vs-table pagination search no-data-text="لا يوجد بيانات" :data="coursesStatistics" :total="coursesStatistics.length">

        <div slot="export" class="flex" slot-scope="{data}">
          <vs-button @click="exportToExcel(data)" class="mt-4 md:mt-0 sm:ml-3 w-full sm:w-auto">إستخراج xlsx</vs-button>
        </div>

        <template slot="thead">
          <vs-th sort-key="course_id">رمز المادة</vs-th>
          <vs-th sort-key="course_name">اسم المادة</vs-th>
          <vs-th sort-key="teacher">الاستاذ</vs-th>
          <vs-th sort-key="group">المجموعة</vs-th>
          <vs-th sort-key="lectures_count">المحاضرات</vs-th>
          <vs-th sort-key="assignments_count">الواجبات</vs-th>
          <vs-th sort-key="quizzes_count">الاختبارات</vs-th>
          <vs-th sort-key="students_count">الطلبة</vs-th>
        </template>

        <tbody slot-scope="{data}">
        <vs-tr v-for="(tr, index) in data" :data="tr" :key="index">
          <vs-td :data="tr.course_id">{{ tr.course_id }}</vs-td>
          <vs-td :data="tr.course_name">{{ tr.course_name }}</vs-td>
          <vs-td :data="tr.teacher">{{ tr.teacher }}</vs-td>
          <vs-td :data="tr.group">{{ tr.group }}</vs-td>
          <vs-td :data="tr.lectures_count">{{ tr.lectures_count }}</vs-td>
          <vs-td :data="tr.assignments_count">{{ tr.assignments_count }}</vs-td>
          <vs-td :data="tr.quizzes_count">{{ tr.quizzes_count }}</vs-td>
          <vs-td :data="tr.students_count">
            <div class="flex items-center">
              {{ tr.students_count }}
              <vx-tooltip
                      v-if="tr.na_students_count" text="طلبات تسجيل لم يتم الموافقة عليها"
                      class="cursor-pointer ml-2"
              >
                <span  class="text-danger">({{ tr.na_students_count }})</span>
              </vx-tooltip>
            </div>
          </vs-td>
        </vs-tr>
        </tbody>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
  import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine'
  import dashboardAPI from '@/api/admin/dashboardAPI'

  export default {
      components: { StatisticsCardLine },
      data () {
          return {
            statistics: null,
          }
      },
      computed: {
          termStatistics() {
            return this.statistics && this.statistics.termStatistics
          },
          coursesStatistics() {
            return this.termStatistics ? this.termStatistics.course_terms.map(ct => {
                return {
                  course_id: ct.course.id,
                  course_name: ct.course.name,
                  teacher: `${ct.teacher.user.first_name} ${ct.teacher.user.middle_name} ${ct.teacher.user.last_name}`,
                  group: ct.group,
                  lectures_count: ct.lectures_count,
                  assignments_count: ct.assignments_count,
                  quizzes_count: ct.quizzes_count,
                  students_count: ct.approved_students_count + ct.not_approved_students_count,
                  na_students_count: ct.not_approved_students_count
                }
            }) : []
          }
      },
      methods: {
        exportToExcel(list) {
          import('@/vendor/Export2Excel').then(excel => {
            const headerTitle = ['رمز المادة', 'اسم المادة', 'الاستاذ', 'المجموعة', 'المحاضرات', 'الواجبات', 'الاختبارات', 'الطلبة', 'طلبات تسجيل لم يتم الموافقة عليها']
            const name = `احصائية المواد الدراسية للفصل الحالي ${this.termStatistics.name}`
            const data = list.map(value => Object.values(value))
            excel.export_json_to_excel({
              header: headerTitle,
              data,
              filename: name,
              desc: name
            })
          })
        },
      },
      beforeRouteEnter(to, from, next) {
        dashboardAPI.statistics()
          .then(({data}) => {
              next(vm => vm.statistics = data)
          }).catch(() => {
              next(vm => vm.$notifyError('حدث خطأ في جلب البيانات...!'))
          })
      }
  }
</script>
